import { render, staticRenderFns } from "./KnowledgeBaseArchiveDetail.vue?vue&type=template&id=d77d7dfc&scoped=true"
import script from "./KnowledgeBaseArchiveDetail.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseArchiveDetail.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseArchiveDetail.vue?vue&type=style&index=0&id=d77d7dfc&prod&lang=css"
import style1 from "./KnowledgeBaseArchiveDetail.vue?vue&type=style&index=1&id=d77d7dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77d7dfc",
  null
  
)

export default component.exports